import script from "./LayoutWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutWrapper.vue?vue&type=script&setup=true&lang=js"

import "./LayoutWrapper.vue?vue&type=style&index=0&id=0147f2d6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0147f2d6"]])

export default __exports__